import BaseRestApi from "../BaseRestApi";
import restEndpoints from "../restEndPointURLs";
import appConstant from "../../../common/constants/appConstant";

const _preparePath = (country) => {
    return restEndpoints.SETUP_INTENT.replace("{{countryCode}}", country.country);
};

const _prepareRequestConfig = (Authorization) => {
    return {
        headers: {
            Authorization,
        },
    };
};

const _preparePayload = ({ prospectId = null }) => {
    return {
        application: {
            name: appConstant.APP_ID,
            identifier: appConstant.APP_ID,
        },
        product: {
            type: "insurance",
            identifier: "Comprehensive_PetInsurance",
        },
        paymentType: "CARD",
        externalReferenceId: prospectId,
        externalReferenceType: appConstant.CUSTOMER_REFERENCE,
        appId: appConstant.APP_ID,
    };
};

class SetupIntentApi extends BaseRestApi.Api {
    constructor(Authorization, prospectId, country) {
        super({
            getPath: () => _preparePath({ country }),
            method: BaseRestApi.methods.POST,
            getRequestConfig: () => _prepareRequestConfig(Authorization),
            getRequestPayload: () => _preparePayload({ prospectId }),
        });
    }
}

export default SetupIntentApi;
